const SmartIdService = {
  isSmartIdEnabled: (smartIdConfig) => {
    const isUserSmartIdEnabled = localStorage.getItem('smartIdEnabled') === "true";
    const countryCode = localStorage.getItem('selectedCountry');
    const isRegionEnabled = smartIdConfig?.[countryCode] === true;
    
    return isRegionEnabled && isUserSmartIdEnabled;
    /**
   @todo: user specific check should be deleted after release testing of SmartId;
    **/ 
  }
};

export default SmartIdService;